export const useApiUrl = () => {
  const config = useRuntimeConfig()
  const baseUrl = ref<string>(import.meta.client ? config.public.apiUrl : config.ssrUrl)
  const apiUrl = ref<string>(`${baseUrl.value}${config.public.apiPrefix}`)

  return {
    apiUrl,
    baseUrl,
  }
}
